// =====================================================
// PRODUCT DATA — BS Agro Equipments
// Product catalogue — https://bsagroequipments.com
// =====================================================

import { PHONE_NUMBER } from "../constants/links";

export const products = [
  {
    "id": 1,
    "name": "3 Feet 16 Blade Single Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹54,000/Piece",
    "badge": "Popular",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2023/8/334085581/EO/KF/CF/20664883/whatsapp-image-2023-08-11-at-15-55-55-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "3 Feet",
      "Brand": "BS Agro",
      "Blades": "16",
      "Model": "MDS 42 TFM",
      "Type": "Single Speed Rotavator"
    },
    "desc": "Entry-level single-speed rotavator with 16 blades and 3 feet working width. Ideal for 35–50 HP tractors on small to medium farms. BS Agro direct manufacturer price from Salem.",
    "features": [
      "Width: 3 Feet",
      "Brand: BS Agro",
      "Blades: 16",
      "Model: MDS 42 TFM",
      "Type: Single Speed Rotavator"
    ]
  },
  {
    "id": 2,
    "name": "5 Feet 24 Blade Weeder Rotavator",
    "cat": "Rotavator",
    "price": "₹1,20,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/2/389277295/AW/VB/AA/20664883/img-20240217-113008-500x500.jpg",
    "imgs": [],
    "spec": {
      "Brand": "B S Agro",
      "Width": "5 Feet",
      "Blades": "24",
      "Type": "Weeder Rotavator",
      "Model": "RD Exle 23"
    },
    "desc": "Specialised weeder rotavator with 24 blades and 5 feet width — combines soil preparation and weed control in one pass.",
    "features": [
      "Brand: B S Agro",
      "Width: 5 Feet",
      "Blades: 24",
      "Type: Weeder Rotavator",
      "Model: RD Exle 23"
    ]
  },
  {
    "id": 3,
    "name": "6 Feet 42 Blade Double Side Drive Rotavator",
    "cat": "Rotavator",
    "price": "₹1,55,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2023/1/PS/KU/SV/20664883/316113481-169468975708021-473813808091560151-n-500x500.jpg",
    "imgs": [],
    "spec": {
      "Width": "6 Feet",
      "Brand": "BS Agro",
      "Blades": "42",
      "Type": "Double Side Drive Rotavator",
      "Model": "RD Exle 21"
    },
    "desc": "Heavy-duty 6 feet double side drive rotavator with 42 blades for deep, uniform tillage on medium to large farms.",
    "features": [
      "Width: 6 Feet",
      "Brand: BS Agro",
      "Blades: 42",
      "Type: Double Side Drive Rotavator",
      "Model: RD Exle 21"
    ]
  },
  {
    "id": 4,
    "name": "3 Feet Reverse Forward Tiller Rotavator",
    "cat": "Rotavator",
    "price": "₹46,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "/products/3ft-reverse-forward-tiller-rotavator.png",
    "imgs": [],
    "video": "/videos/3ft-reverse-forward-tiller-rotavator.mp4",
    "searchTerms": [
      "3 feet reverse forward tiller rotavator",
      "reverse forward tiller rotavator",
      "3 feet reverse forward tiller",
      "22 blade reverse forward"
    ],
    "spec": {
      "Material": "Mild Steel",
      "Width": "3 Feet",
      "Brand": "BS AGRO",
      "Usage": "Agriculture",
      "Blades": "22",
      "Type": "Reverse Forward Tiller Rotavator"
    },
    "desc": "3 feet reverse forward tiller rotavator with 22 Y-type blades, mild steel build. Runs in both directions — saves fuel and labour on compact fields.",
    "features": [
      "Material: Mild Steel",
      "Width: 3 Feet",
      "Brand: BS AGRO",
      "Usage: Agriculture",
      "Blades: 22",
      "Type: Reverse Forward Tiller Rotavator"
    ]
  },
  {
    "id": 5,
    "name": "24 Blade 4 Feet Mini Rotavator",
    "cat": "Rotavator",
    "price": "₹60,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/GLADMIN/VideoImage/2023/8/332566186/XD/RG/AE/20664883/mini-rotavator-4-feet-500x500.jpg",
    "imgs": [],
    "spec": {
      "Brand": "BS Agro",
      "Width": "4 Feet",
      "Blades": "24",
      "Type": "Mini Rotavator",
      "Model": "RD Exle 52"
    },
    "desc": "Compact 4 feet mini rotavator with 24 blades — ideal for smaller tractors and narrow fields.",
    "features": [
      "Brand: BS Agro",
      "Width: 4 Feet",
      "Blades: 24",
      "Type: Mini Rotavator",
      "Model: RD Exle 52"
    ]
  },
  {
    "id": 6,
    "name": "42 Blade Double Side Drive High Clearance Rotavator",
    "cat": "Rotavator",
    "price": "₹1,42,600/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2023/1/YX/OS/SU/20664883/whatsapp-image-2023-01-11-at-20-50-53-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Brand": "BS Agro",
      "Width": "6 Feet",
      "HP": "60 HP",
      "Blades": "42",
      "Type": "Multi Speed Rotavator",
      "Model": "RD Exle 17"
    },
    "desc": "42 Blade Double Side Drive High Clearance Rotavator from B S Agro Equipments, Salem. Key details: Brand: BS Agro · Width: 6 Feet · HP: 60 HP · Blades: 42. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Brand: BS Agro",
      "Width: 6 Feet",
      "HP: 60 HP",
      "Blades: 42",
      "Type: Multi Speed Rotavator",
      "Model: RD Exle 17"
    ]
  },
  {
    "id": 7,
    "name": "42 Blade Heavy Duty High Clearance Multi Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹1,07,500/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "/products/42-blade-6ft-multispeed-rotavator-1.png",
    "imgs": [
      "/products/42-blade-6ft-multispeed-rotavator-2.png",
      "/products/42-blade-6ft-multispeed-rotavator-3.png"
    ],
    "spec": {
      "Width": "6 Feet",
      "HP": "50 HP",
      "Blades": "42",
      "Brand": "B S Agro",
      "Type": "Multi Speed Rotavator",
      "Model": "RD Exle 12"
    },
    "desc": "42 Blade Heavy Duty High Clearance Multi Speed Rotavator from B S Agro Equipments, Salem. Key details: Width: 6 Feet · HP: 50 HP · Blades: 42 · Brand: B S Agro. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 6 Feet",
      "HP: 50 HP",
      "Blades: 42",
      "Brand: B S Agro",
      "Type: Multi Speed Rotavator",
      "Model: RD Exle 12"
    ]
  },
  {
    "id": 8,
    "name": "42 Blade Medium Heavy High Clearance Multi Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹1,01,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2022/12/KF/YY/QW/20664883/mild-steel-rotavator-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "6.5",
      "Brand": "BS Agro",
      "Blades": "42",
      "Model": "RD Exle 10"
    },
    "desc": "42 Blade Medium Heavy High Clearance Multi Speed Rotavator from B S Agro Equipments, Salem. Key details: Width: 6.5 · Brand: BS Agro · Blades: 42 · Model: RD Exle 10. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 6.5",
      "Brand: BS Agro",
      "Blades: 42",
      "Model: RD Exle 10"
    ]
  },
  {
    "id": 9,
    "name": "48 LJF Blade Multi Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹1,18,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2025/7/531104649/MR/CV/BC/20664883/rd-exle-10-multi-speed-rotavator-500x500.jpg",
    "imgs": [],
    "spec": {
      "Width": "7.5",
      "HP": "55",
      "Brand": "BS Agro",
      "Blades": "48",
      "Type": "Multi Speed Rotavator"
    },
    "desc": "48 LJF Blade Multi Speed Rotavator from B S Agro Equipments, Salem. Key details: Width: 7.5 · HP: 55 · Brand: BS Agro · Blades: 48. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 7.5",
      "HP: 55",
      "Brand: BS Agro",
      "Blades: 48",
      "Type: Multi Speed Rotavator"
    ]
  },
  {
    "id": 10,
    "name": "20 Blade 3.5 Feet Mini Rotavator",
    "cat": "Rotavator",
    "price": "₹60,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2023/8/334093830/PZ/MT/SH/20664883/whatsapp-image-2023-08-11-at-16-09-39-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "3.5 Feet",
      "Blades": "20",
      "Brand": "BS Agro",
      "Type": "Mini Rotavator",
      "Model": "RD Exle 54"
    },
    "desc": "Compact 3.5 feet mini rotavator with 20 blades — ideal for small tractors and tight field work.",
    "features": [
      "Width: 3.5 Feet",
      "Blades: 20",
      "Brand: BS Agro",
      "Type: Mini Rotavator",
      "Model: RD Exle 54"
    ]
  },
  {
    "id": 11,
    "name": "42 Blade Multi Speed Regular Rotavator",
    "cat": "Rotavator",
    "price": "₹92,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/1/380836391/WK/FY/QF/20664883/multi-speed-rotavator-gearbox-500x500.jpg",
    "imgs": [],
    "spec": {
      "Brand": "BS Agro",
      "Width": "6 Feet",
      "Blades": "42 Blade",
      "Model": "RD Exle 18",
      "Type": "Multi Speed Rotavator"
    },
    "desc": "42 Blade Multi Speed Regular Rotavator from B S Agro Equipments, Salem. Key details: Brand: BS Agro · Width: 6 Feet · Blades: 42 Blade · Model: RD Exle 18. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Brand: BS Agro",
      "Width: 6 Feet",
      "Blades: 42 Blade",
      "Model: RD Exle 18",
      "Type: Multi Speed Rotavator"
    ]
  },
  {
    "id": 12,
    "name": "36 Blade Multi Speed Regular Rotavator",
    "cat": "Rotavator",
    "price": "₹89,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2022/12/SN/BM/YZ/20664883/mild-steel-multi-speed-rotavator-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "5 Feet",
      "Brand": "BS Agro",
      "HP": "40 HP",
      "Blades": "36",
      "Type": "Multi Speed Rotavator"
    },
    "desc": "36 Blade Multi Speed Regular Rotavator from B S Agro Equipments, Salem. Key details: Width: 5 Feet · Brand: BS Agro · HP: 40 HP · Blades: 36. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 5 Feet",
      "Brand: BS Agro",
      "HP: 40 HP",
      "Blades: 36",
      "Type: Multi Speed Rotavator"
    ]
  },
  {
    "id": 13,
    "name": "28 Blade Multi Speed Regular Rotavator",
    "cat": "Rotavator",
    "price": "₹78,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2023/4/298873944/JD/HT/AZ/20664883/bs-agro-rotavators-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "4.5",
      "HP": "30 HP",
      "Brand": "BS Agro",
      "Blades": "24",
      "Type": "Multi Speed Rotavator",
      "Model": "RD Exle 4"
    },
    "desc": "28 Blade Multi Speed Regular Rotavator from B S Agro Equipments, Salem. Key details: Width: 4.5 · HP: 30 HP · Brand: BS Agro · Blades: 24. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 4.5",
      "HP: 30 HP",
      "Brand: BS Agro",
      "Blades: 24",
      "Type: Multi Speed Rotavator",
      "Model: RD Exle 4"
    ]
  },
  {
    "id": 14,
    "name": "20 Blade Single Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹57,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2023/8/334312304/KY/NE/PX/20664883/whatsapp-image-2023-08-11-at-16-09-37-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "3.5",
      "HP": "20 HP",
      "Brand": "BS Agro",
      "Blades": "20",
      "Type": "Single Speed Rotavator"
    },
    "desc": "20 Blade Single Speed Rotavator from B S Agro Equipments, Salem. Key details: Width: 3.5 · HP: 20 HP · Brand: BS Agro · Blades: 20. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 3.5",
      "HP: 20 HP",
      "Brand: BS Agro",
      "Blades: 20",
      "Type: Single Speed Rotavator"
    ]
  },
  {
    "id": 15,
    "name": "36 Blade Medium Heavy High Clearance Multi Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹95,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2025/7/531168835/KF/UX/FH/20664883/whatsapp-image-2025-07-27-at-10-46-10-am-2-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "5 Feet",
      "HP": "40 HP",
      "Brand": "B S Agro",
      "Blades": "36",
      "Type": "Multi Speed Rotavator Gearbox",
      "Output": "280 RPM"
    },
    "desc": "36 Blade Medium Heavy High Clearance Multi Speed Rotavator from B S Agro Equipments, Salem. Key details: Width: 5 Feet · HP: 40 HP · Brand: B S Agro · Blades: 36. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 5 Feet",
      "HP: 40 HP",
      "Brand: B S Agro",
      "Blades: 36",
      "Type: Multi Speed Rotavator Gearbox",
      "Output: 280 RPM"
    ]
  },
  {
    "id": 16,
    "name": "42 Blade Ultra Clearance Banana Rotavator",
    "cat": "Rotavator",
    "price": "₹1,45,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/3/405192677/PB/DR/QK/20664883/freeimagekit-com-img-size-px-500x500.jpg",
    "imgs": [],
    "spec": {
      "Width": "7 Feet",
      "Blades": "42",
      "Type": "Ultra Clearance Banana Rotavator",
      "Material": "Mild Steel",
      "Brand": "B S Agro",
      "Clearance": "Ultra High"
    },
    "desc": "42 blade ultra clearance banana rotavator for plantation tillage — heavy-duty build for banana and wide-row crops.",
    "features": [
      "Width: 7 Feet",
      "Blades: 42",
      "Type: Ultra Clearance Banana Rotavator",
      "Material: Mild Steel",
      "Brand: B S Agro",
      "Clearance: Ultra High"
    ]
  },
  {
    "id": 18,
    "name": "34 Inch Rotavator PTO Shaft",
    "cat": "Accessories",
    "price": "₹5,300/Piece",
    "badge": "",
    "icon": "🔩",
    "img": "https://5.imimg.com/data5/SELLER/Default/2021/10/XN/PM/AT/20664883/mild-steel-pto-shaft-500x500.jpg",
    "imgs": [],
    "spec": {
      "Usage": "Rotavator",
      "Material": "Mild Steel",
      "Color": "Yellow",
      "Brand": "B S Agro",
      "Length": "34 inch",
      "Type": "Rotavator PTO Shaft"
    },
    "desc": "34 Inch Rotavator PTO Shaft from B S Agro Equipments, Salem. Key details: Usage: Rotavator · Material: Mild Steel · Color: Yellow · Brand: B S Agro. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Usage: Rotavator",
      "Material: Mild Steel",
      "Color: Yellow",
      "Brand: B S Agro",
      "Length: 34 inch",
      "Type: Rotavator PTO Shaft"
    ]
  },
  {
    "id": 19,
    "name": "Rotavator Side Gear Drive",
    "cat": "Accessories",
    "price": "₹5,800/Set",
    "badge": "",
    "icon": "🔩",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/3/405197048/LO/XU/QN/20664883/rotavator-side-gear-21-36-28-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Material": "Stainless Steel",
      "Type": "Rotavator Side Gear Drive",
      "Usage": "Rotavator",
      "Shape": "Round",
      "Surface": "Polished",
      "Grade": "353"
    },
    "desc": "Rotavator Side Gear Drive from B S Agro Equipments, Salem. Key details: Material: Stainless Steel · Type: Rotavator Side Gear Drive · Usage: Rotavator · Shape: Round. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Material: Stainless Steel",
      "Type: Rotavator Side Gear Drive",
      "Usage: Rotavator",
      "Shape: Round",
      "Surface: Polished",
      "Grade: 353"
    ]
  },
  {
    "id": 28,
    "name": "Rotavator Blade",
    "cat": "Accessories",
    "price": "₹140/Piece",
    "badge": "",
    "icon": "🔩",
    "img": "https://5.imimg.com/data5/SELLER/Default/2022/12/BN/CJ/MX/20664883/mild-steel-rotavator-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Type": "Rotavator Blade",
      "Material": "High Carbon Steel",
      "Usage": "Rotavator",
      "Brand": "B S Agro"
    },
    "desc": "Replacement rotavator blade — high carbon steel, BS Agro factory quality. ₹140 per piece.",
    "features": [
      "Type: Rotavator Blade",
      "Material: High Carbon Steel",
      "Usage: Rotavator",
      "Brand: B S Agro",
      "Factory-direct pricing"
    ]
  },
  {
    "id": 29,
    "name": "Blade Bolt Nut",
    "cat": "Accessories",
    "price": "₹25/Set",
    "badge": "",
    "icon": "🔩",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/3/405197048/LO/XU/QN/20664883/rotavator-side-gear-21-36-28-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Type": "Blade Bolt Nut",
      "Usage": "Rotavator Blade Fixing",
      "Material": "Mild Steel",
      "Brand": "B S Agro"
    },
    "desc": "Rotavator blade bolt and nut set for secure blade mounting. ₹25 per set.",
    "features": [
      "Type: Blade Bolt Nut",
      "Usage: Rotavator Blade Fixing",
      "Material: Mild Steel",
      "Brand: B S Agro",
      "Complete bolt & nut set"
    ]
  },
  {
    "id": 20,
    "name": "Reverse Forward Tiller Rotavator",
    "cat": "Tiller",
    "price": "₹79,500/Unit",
    "badge": "",
    "icon": "🌱",
    "img": "https://5.imimg.com/data5/ANDROID/Default/2022/8/JD/QY/JZ/20664883/product-jpeg-500x500.jpg",
    "imgs": [],
    "spec": {
      "Brand": "B S Agro",
      "Blades": "36",
      "Width": "5 Feet",
      "Type": "Reverse Forward Tiller",
      "Material": "Mild Steel",
      "Color": "Orange"
    },
    "desc": "Reverse and forward tiller rotavator with 36 blades and 5 feet width — versatile soil preparation in both directions.",
    "features": [
      "Brand: B S Agro",
      "Blades: 36",
      "Width: 5 Feet",
      "Type: Reverse Forward Tiller",
      "Material: Mild Steel",
      "Color: Orange"
    ]
  },
  {
    "id": 21,
    "name": "4 Feet 30 Blade Multi Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹75,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2022/12/AE/FQ/LZ/20664883/bs-agro-equipments-500x500.jpeg",
    "imgs": [],
    "spec": {
      "Width": "4 Feet",
      "Brand": "BS Agro",
      "Blades": "48",
      "Product Type": "Multi Speed Rotavator",
      "Model": "RD Exle 6"
    },
    "desc": "4 Feet 30 Blade Multi Speed Rotavator from B S Agro Equipments, Salem. Key details: Width: 4 Feet · Brand: BS Agro · Blades: 48 · Product Type: Multi Speed Rotavator. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Width: 4 Feet",
      "Brand: BS Agro",
      "Blades: 48",
      "Product Type: Multi Speed Rotavator",
      "Model: RD Exle 6"
    ]
  },
  {
    "id": 22,
    "name": "29 Inch Rotavator Side Disk",
    "cat": "Side Disk",
    "price": "₹4,200/Piece",
    "badge": "",
    "icon": "💿",
    "img": "https://5.imimg.com/data5/SELLER/Default/2022/10/JT/RW/XS/20664883/product-jpeg-500x500.jpg",
    "imgs": [],
    "spec": {
      "Brand": "BS AGRO",
      "Width": "7 Feet",
      "Tilling Width": "29 Inches",
      "Blade Type": "Round",
      "Usage": "Rotavator",
      "Material": "MS"
    },
    "desc": "29 Inch Rotavator Side Disk from B S Agro Equipments, Salem. Key details: Brand: BS AGRO · Width: 7 Feet · Tilling Width: 29 Inches · Blade Type: Round. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Brand: BS AGRO",
      "Width: 7 Feet",
      "Tilling Width: 29 Inches",
      "Blade Type: Round",
      "Usage: Rotavator",
      "Material: MS"
    ]
  },
  {
    "id": 23,
    "name": "42H MS 2024 RD Agricultural Ridger",
    "cat": "Ridger",
    "price": "₹1,20,000/Piece",
    "badge": "",
    "icon": "🌾",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/1/380817267/FL/OI/KA/20664883/compressjpeg-online-image-500x500.jpg",
    "imgs": [],
    "spec": {
      "Usage": "Agriculture",
      "Material": "Mild Steel",
      "Type": "Tractor Mounted",
      "Model": "42H-MS-2024-RD",
      "Brand": "B S Agro",
      "Product Type": "Ridger"
    },
    "desc": "42H MS 2024 RD Agricultural Ridger from B S Agro Equipments, Salem. Key details: Usage: Agriculture · Material: Mild Steel · Type: Tractor Mounted · Model: 42H-MS-2024-RD. Direct manufacturer of rotavators and agricultural machinery. Call for quote and Tamil Nadu delivery.",
    "features": [
      "Usage: Agriculture",
      "Material: Mild Steel",
      "Type: Tractor Mounted",
      "Model: 42H-MS-2024-RD",
      "Brand: B S Agro",
      "Product Type: Ridger"
    ]
  },
  {
    "id": 24,
    "name": "Hydraulic Reversible M B Plough",
    "cat": "New Items",
    "price": "₹85,000/Piece",
    "badge": "New",
    "icon": "✨",
    "img": "/products/hydraulic-mb-plough-1.png",
    "imgs": [
      "/products/hydraulic-mb-plough-2.png"
    ],
    "spec": {
      "HP": "45 HP",
      "Tynes": "2 Tynes",
      "Brand": "BS AGRO",
      "Working Depth": "20 Inches",
      "Type": "Reversible Plough",
      "Number of Disc/Furrow": "2"
    },
    "desc": "Hydraulic reversible MB plough for 45 HP tractors, 2 tynes. Efficient primary tillage with auto reset.",
    "features": [
      "HP: 45 HP",
      "Tynes: 2 Tynes",
      "Brand: BS AGRO",
      "Working Depth: 20 Inches",
      "Type: Reversible Plough",
      "Number of Disc/Furrow: 2"
    ]
  },
  {
    "id": 27,
    "name": "7 Feet 48 Blade Multi Speed Rotavator",
    "cat": "Rotavator",
    "price": "₹1,15,000/Piece",
    "badge": "",
    "icon": "🔄",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/1/380840176/BN/KL/WF/20664883/7-feet-rotavator-500x500.jpg",
    "imgs": [],
    "spec": {
      "Width": "7 Feet",
      "Blades": "48",
      "Type": "Multi Speed Rotavator",
      "Brand": "BS Agro",
      "HP": "55 HP"
    },
    "desc": "Heavy-duty 7 feet multi-speed rotavator with 48 blades for large farms and plantation tillage. Adjustable speeds for different soil conditions.",
    "features": [
      "Width: 7 Feet",
      "Blades: 48",
      "Type: Multi Speed Rotavator",
      "Brand: BS Agro",
      "HP: 55 HP",
      "ISO certified quality"
    ]
  },
  {
    "id": 30,
    "name": "9 Tine Cultivator 2 1/4 Safe 3 Feet Arm Cultivator",
    "cat": "Cultivator",
    "price": "₹44,000/Piece",
    "badge": "New",
    "icon": "🌾",
    "img": "/products/9-arm-cultivator.png",
    "imgs": [],
    "spec": {
      "Tynes": "9 Tynes",
      "Arm Size": "2 1/4 Safe",
      "Width": "3 Feet",
      "Type": "Cultivator",
      "Brand": "B S Agro"
    },
    "desc": "9 tine cultivator with 2 1/4 safe 3 feet arm — reliable secondary tillage for medium farms.",
    "features": [
      "Tynes: 9 Tynes",
      "Arm Size: 2 1/4 Safe",
      "Width: 3 Feet",
      "Type: Cultivator",
      "Brand: B S Agro",
      "BS Agro factory quality"
    ]
  },
  {
    "id": 31,
    "name": "5 Tine Duck Feet Cultivator",
    "cat": "Cultivator",
    "price": "₹57,000/Piece",
    "badge": "New",
    "icon": "🌾",
    "img": "/products/5-tine-duck-feet-cultivator.png",
    "imgs": [],
    "spec": {
      "Tynes": "5 Tynes",
      "Type": "Duck Feet Cultivator",
      "Brand": "B S Agro",
      "Usage": "Agriculture"
    },
    "desc": "5 tine duck feet cultivator for effective soil loosening and weed control between crop rows.",
    "features": [
      "Tynes: 5 Tynes",
      "Type: Duck Feet Cultivator",
      "Brand: B S Agro",
      "Usage: Agriculture",
      "Durable duck feet tines",
      "Tractor mounted"
    ]
  },
  {
    "id": 32,
    "name": "Gauge Wheels",
    "cat": "Cultivator",
    "price": "₹38,000/Piece",
    "badge": "",
    "icon": "🌾",
    "img": "/products/gage-wheels.png",
    "imgs": [],
    "spec": {
      "Type": "Gauge Wheels",
      "Brand": "B S Agro",
      "Usage": "Cultivator / Ridger",
      "Material": "Mild Steel"
    },
    "desc": "Gauge wheels for cultivators and ridgers — depth control and stable field operation.",
    "features": [
      "Type: Gauge Wheels",
      "Brand: B S Agro",
      "Usage: Cultivator / Ridger",
      "Material: Mild Steel",
      "Depth control support"
    ]
  },
  {
    "id": 33,
    "name": "Spring Cultivator 9 Arm",
    "cat": "Cultivator",
    "price": "₹42,000/Piece",
    "badge": "New",
    "icon": "🌾",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/1/380817267/FL/OI/KA/20664883/compressjpeg-online-image-500x500.jpg",
    "imgs": [],
    "spec": {
      "Arms": "9 Arm",
      "Type": "Spring Cultivator",
      "Brand": "B S Agro",
      "Usage": "Agriculture"
    },
    "desc": "Spring cultivator with 9 arms for flexible tillage. Bush type also available at ₹44,000.",
    "features": [
      "Arms: 9 Arm",
      "Type: Spring Cultivator",
      "Brand: B S Agro",
      "Spring-loaded tines",
      "Bush type available — ₹44,000"
    ]
  },
  {
    "id": 34,
    "name": "Spring Cultivator 9 Arm (Bush Type)",
    "cat": "Cultivator",
    "price": "₹44,000/Piece",
    "badge": "New",
    "icon": "🌾",
    "img": "https://5.imimg.com/data5/SELLER/Default/2024/1/380817267/FL/OI/KA/20664883/compressjpeg-online-image-500x500.jpg",
    "imgs": [],
    "spec": {
      "Arms": "9 Arm",
      "Type": "Spring Cultivator Bush Type",
      "Brand": "B S Agro",
      "Usage": "Agriculture"
    },
    "desc": "Spring cultivator 9 arm with bush type fitting — enhanced durability for tough soil conditions.",
    "features": [
      "Arms: 9 Arm",
      "Type: Bush Type",
      "Brand: B S Agro",
      "Spring cultivator design",
      "Heavy-duty bush type arms"
    ]
  }
];

export const reviews = [
  { init: "N", name: "Naveen Kumar", loc: "Hosur, Tamil Nadu", stars: 5, prod: "Hydraulic Reversible Plough", date: "21-Jan-2026", text: "Excellent build quality. The plough worked perfectly on my red soil fields with zero issues." },
  { init: "B", name: "Balamurugan", loc: "Villupuram, Tamil Nadu", stars: 5, prod: "Rotavator", date: "17-Dec-2025", text: "The rotavator finished my 3-acre field in one afternoon. Very satisfied with the product and delivery." },
  { init: "R", name: "Rajendran", loc: "Coimbatore, Tamil Nadu", stars: 4, prod: "250 RPM Gear Box", date: "05-Nov-2025", text: "Good product, delivery was prompt. The gear box is durable and quiet. Runs without vibrations." },
  { init: "S", name: "Selvam", loc: "Madurai, Tamil Nadu", stars: 5, prod: "3 Feet 16 Blade Rotavator", date: "14-Oct-2025", text: "Best rotavator in this price range. The blades are strong and lasted through the entire kharif season." },
  { init: "M", name: "Murugesan", loc: "Trichy, Tamil Nadu", stars: 3, prod: "Side Disk", date: "02-Sep-2025", text: "Product is okay, took longer to arrive than expected. Quality is decent but fitting took some adjustment." },
  { init: "K", name: "Karthikeyan", loc: "Salem, Tamil Nadu", stars: 5, prod: "42H MS 2024 RD Ridger", date: "18-Aug-2025", text: "The 2024 RD ridger is excellent. Creates perfect ridges for sugarcane. Highly recommend BS Agro." },
  { init: "A", name: "Arunachalam", loc: "Tirunelveli, Tamil Nadu", stars: 5, prod: "Single Speed Rotary Tiller", date: "04-Jul-2025", text: "Good quality tiller. Sturdy frame and blades cut through compacted soil well. Worth every rupee." },
];

export const tickItems = [
  "🔄 Agriculture Rotavators · ISO Certified · Direct Factory Price",
  "⚙️ 250 RPM Gear Boxes · Heavy Duty · Salem Manufacturing",
  "🚚 Free Delivery on Select Models · Tamil Nadu",
  "🌾 2024 RD Series Now Available · Ridgers & Ploughs",
  `📞 Call ${PHONE_NUMBER} for Bulk Order Discounts`,
  "★ 4.4/5 Rated · 43 Verified Reviews · GST: 33FJKPS8217P1ZC",
];
